module.exports = __webpack_public_path__ + "img/plate02_01.af25b6a6.png";